export default {"src":"/_next/static/media/learning.98d8243f.svg","height":753,"width":1077};